import { RealEstate } from '../../../../@types/real-estate-api-types'

export const apiSearchDataToApp = (realEstate: RealEstate) => ({
  searchField1: realEstate.apiSearchData?.searchField1,
  searchField2: realEstate.apiSearchData?.searchField2,
  searchField3: realEstate.apiSearchData?.searchField3,
})
